import { render, staticRenderFns } from "./SubscriptionTypeCreate.vue?vue&type=template&id=216105cd&scoped=true"
import script from "./SubscriptionTypeCreate.vue?vue&type=script&lang=js"
export * from "./SubscriptionTypeCreate.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTypeCreate.vue?vue&type=style&index=0&id=216105cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216105cd",
  null
  
)

export default component.exports